import React from 'react';
import { Input, Checkbox, Button } from 'clad-ui';
import { useForm, Controller } from 'react-hook-form';
import { styled } from '@linaria/react';
import { dataLayerPush } from '@chotot/web-gtm';
import { POLICY_URL, PRIVACY_URL } from '~/constants';
import { asyncGTMClickEvent } from '~/helpers/tagging/gtm';
import SecurePasswordControl from '~/components/common/SecurePasswordControl';
export type RegisterInputs = {
  name: string;
  password: string;
  phone: string;
  acceptPolicy: boolean;
};
type Props = {
  onSubmit?: (data: RegisterInputs) => void;
  isLoading?: boolean;
  defaultValue?: Partial<RegisterInputs>;
  onInvalid?: () => void;
};
const RegisterForm = (props: Props) => {
  const {
    defaultValue,
    isLoading = false,
    onSubmit: onRegister = () => {},
    onInvalid = () => {}
  } = props;
  const {
    control,
    handleSubmit
  } = useForm<RegisterInputs>({
    values: {
      name: defaultValue?.name || '',
      phone: defaultValue?.phone || '',
      password: '',
      acceptPolicy: true
    }
  });
  const acceptNumberOnly = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.replace(/\D/g, '');
    return event;
  };
  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    handleSubmit(onRegister, onInvalid)();
  };
  const onNameFocus = () => {
    dataLayerPush({
      event: 'track_event',
      event_category: 'sign_up',
      event_action: 'input',
      event_label: 'input_username'
    });
  };
  const onPolicyClick = () => {
    asyncGTMClickEvent({
      category: 'sign_up',
      label: 'terms_of_use'
    });
  };
  return <FormWrapper method="post" onSubmit={onSubmit}>
      {/** Use these inputs to disable autofill in chrome */}
      <input id="hidden-phone-input" style={{
      height: 0,
      border: 0,
      padding: 0
    }} type="tel" name="hidden-phone" />
      <input id="hidden-password-input" style={{
      height: 0,
      border: 0,
      padding: 0
    }} type="password" name="hidden-password" />

      <Controller name="name" control={control} rules={{
      required: {
        value: true,
        message: 'Vui lòng nhập họ và tên.'
      },
      maxLength: {
        value: 100,
        message: 'Họ và tên không quá 100 ký tự.'
      },
      pattern: {
        value: /^[^-_[\]{}()*+=?.,\\^$|#!@%&/<>]*$/g,
        message: 'Họ và tên không chứa ký tự đặc biệt.'
      }
    }} render={({
      field: {
        ref,
        ...field
      },
      fieldState: {
        invalid,
        error
      }
    }) => <Input {...field} id="name-input" label="Họ và tên" helptext={error?.message} status={invalid ? 'error' : 'default'} allowClear onFocus={onNameFocus} />} />
      <Controller name="phone" control={control} rules={{
      required: {
        value: true,
        message: 'Vui lòng nhập số điện thoại.'
      },
      pattern: {
        value: /^0\d{9}$/,
        message: 'Số điện thoại không hợp lệ.'
      }
    }} render={({
      field: {
        ref,
        ...field
      },
      fieldState: {
        invalid,
        error
      }
    }) => <Input {...field} id="phone-input" label="Số điện thoại" type="tel" inputMode="numeric" helptext={error?.message} status={invalid ? 'error' : 'default'} allowClear onChange={(event: React.ChangeEvent<HTMLInputElement>) => field.onChange(acceptNumberOnly(event))} />} />
      <SecurePasswordControl name="password" label="Mật khẩu" control={control} />

      <div className="policy-acceptance">
        <Controller name="acceptPolicy" control={control} render={({
        field
      }) => <Checkbox checked={field.value} onChange={field.onChange} />} />
        <p>
          Bằng việc Đăng ký, bạn đã đọc và đồng ý với{' '}
          <a id="policy-link" href={POLICY_URL} target="_blank" onClick={onPolicyClick}>
            Điều khoản sử dụng
          </a>{' '}
          và{' '}
          <a id="privacy-link" href={PRIVACY_URL} target="_blank">
            Chính sách bảo mật
          </a>{' '}
          của Chợ Tốt
        </p>
      </div>

      <Button id="register-btn" stretch size="large" weight="bold" isLoading={isLoading}>
        ĐĂNG KÝ
      </Button>
    </FormWrapper>;
};
const FormWrapper = /*#__PURE__*/styled('form')({
  name: "FormWrapper",
  class: "fs0he67",
  propsAsIs: false
});
export default RegisterForm;

require("./RegisterForm.linaria.module.css");